'use client';

import { useEffect } from 'react';
import { useStore } from '@/store/store';
import { COOKIES } from '@/utils/cookies';
import { getConfig } from '@/utils/config/config';
import { getCookieValue } from '@/utils/cookies/client';

const SIFT_LICENSED_STATES = ['NJ', 'MI', 'WV', 'PA', 'CT', 'MR'];

export const SiftTracker = () => {
    const { siftBeaconKey } = getConfig();
    const region = useStore((state) => state?.regionInfo?.currentRegion?.region);
    const sessionId = getCookieValue(COOKIES.SESSION_ID) as string;
    const userId = getCookieValue(COOKIES.USER_ID) as string;

    useEffect(() => {
        if (siftBeaconKey && region && SIFT_LICENSED_STATES.includes(region) && userId && sessionId) {
            if (!window._sift) {
                window._sift = [];

                const siftSnippet = document.createElement('script');
                siftSnippet.type = 'text/javascript';
                siftSnippet.innerHTML = `
        var _sift = window._sift = window._sift || [];
        _sift.push(['_setAccount', '${siftBeaconKey}']);
        (function() {
          function ls() {
            var e = document.createElement('script');
            e.src = 'https://cdn.sift.com/s.js';
            document.body.appendChild(e);
          }
          if (window.attachEvent) {
            window.attachEvent('onload', ls);
          } else {
            window.addEventListener('load', ls, false);
          }
        })();
      `;
                document.body.appendChild(siftSnippet);
            }

            window._sift.push(['_setUserId', userId]);
            window._sift.push(['_setSessionId', sessionId]);
            window._sift.push(['_trackPageview']);
        }
    }, []);

    return null;
};
